<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'DisciplinePaymentRow',
})

withDefaults(defineProps<{
  label: string
  value: string
  percent?: number | null
  bold?: boolean
}>(), {
  percent: null,
  bold: false,
})
</script>

<template>
  <div class="discipline-payment-row">
    <div class="discipline-payment-row__label">
      <AppText :name="bold ? 'h3' : 'body1'">
        {{ label }}
      </AppText>
      <AppText
        v-if="percent !== null"
        name="body1-medium"
      >
        {{ percent }}%
      </AppText>
    </div>
    <AppText
      :name="bold ? 'h3' : 'body1'"
      :color="percent !== null ? 'red-600' : 'slate-900'"
    >
      {{ value }}
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./DisciplinePaymentRow.scss" />
